import React from 'react';

const AIDisclaimerPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FFF4E6] to-[#FAFAF8]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-4">
              AI & Services Disclaimer
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            
            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Use of Artificial Intelligence</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                TekClap utilizes artificial intelligence (AI) technologies as assistive tools to enhance our services and improve user experience. AI is employed to support, not replace, human judgment and decision-making.
              </p>
              <p className="text-[#6B7280] leading-relaxed">
                Our AI-powered features, including but not limited to chatbots and automated responses, are designed to provide helpful information and streamline communication. However, these tools should not be considered as providing definitive professional advice.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Human Oversight</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                No fully automated decisions regarding employment, hiring, or significant business matters are made without appropriate human oversight and review. TekClap maintains human involvement in all consequential decisions affecting individuals and organizations.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Consulting and Technology Services</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                All consulting, technology, and professional services provided by TekClap are subject to the terms and conditions defined in individual contractual agreements between TekClap and its clients. Service scope, deliverables, and outcomes are determined through formal engagement processes.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Informational Content</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                The content provided on this website, including information generated or assisted by AI, is for informational purposes only and does not constitute:
              </p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2 mb-4">
                <li>Legal advice or legal opinion</li>
                <li>Financial or investment advice</li>
                <li>Professional consulting recommendations</li>
                <li>Guarantees of specific outcomes or results</li>
              </ul>
              <p className="text-[#6B7280] leading-relaxed">
                Users should consult with qualified professionals for advice specific to their circumstances.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Accuracy and Limitations</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                While we strive to provide accurate and up-to-date information, AI systems may occasionally produce responses that are incomplete or inaccurate. TekClap is not liable for any actions taken based solely on AI-generated content without appropriate verification and professional consultation.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Contact</h2>
              <p className="text-[#6B7280] leading-relaxed">
                If you have questions about our use of AI or our services, please contact us at{' '}
                <a href="mailto:info@tekclap.com" className="text-[#F58B23] hover:underline">info@tekclap.com</a>.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default AIDisclaimerPage;
